export default __webpack_public_path__ + "static/media/white_arrow.fe6acb7d.svg";